import Swal from 'sweetalert2';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from '@angular/forms';
import { DocumentCategoryDto, DocumentSubCategoryDto } from '@cradua/data';

@Component({
  selector: 'mrsoftapps-document-sub-category-view',
  templateUrl: './document-sub-category-view.component.html',
  styleUrls: ['./document-sub-category-view.component.css'],
})
export class DocumentSubCategoryViewComponent implements OnInit {
  @Input() documentCategories: DocumentCategoryDto[];
  @Input() documentSubCategories: DocumentSubCategoryDto[];
  documentSubCategoryForm: FormGroup;
  control = new FormControl();
  @Output() changeEmit = new EventEmitter<DocumentSubCategoryDto>();
  @Output() deleteEvent = new EventEmitter<any>();

  selectedDocumentCategory: any;
  filteredDelete: Array<any> = [];
  loading = true;
  filteredDocumentSubCategory: Array<any> = [];
  status: boolean;
  selectedDocumentCategoryId: any;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.documentSubCategoryForm = this.fb.group({
      DocumentSubCategories: this.fb.array([]),
    });
  }

  // method to display countries
  setDocumentSubCategory() {
    const control = this.documentSubCategoryForm.controls
      .DocumentSubCategories as FormArray;
    this.filteredDocumentSubCategory.forEach((e) => {
      control.push(
        this.fb.group({
          DocumentSubCategoryName: e.DocumentSubCategoryName,
          DocumentCategoryId: e.DocumentCategoryId,
          id: e.id,
        })
      );
    });
  }

  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.documentSubCategoryForm.controls
      .DocumentSubCategories as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to filter state
  selectDocumentSubCategory(event: string) {
    this.filteredDocumentSubCategory = this.documentSubCategories.filter(
      (s) => s.DocumentCategoryId === event
    );
    this.selectedDocumentCategoryId = event;
    const control = this.documentSubCategoryForm.controls
      .DocumentSubCategories as FormArray;

    if (this.filteredDocumentSubCategory.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setDocumentSubCategory();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }
  }

  // method to add Country
  addDocumentSubCategory() {
    const control = this.documentSubCategoryForm.controls
      .DocumentSubCategories as FormArray;
    control.insert(
      0,
      this.fb.group({
        DocumentSubCategoryName: ['', Validators.required],
        DocumentCategoryId: this.selectedDocumentCategoryId,
        id: null,
      })
    );
  }

  print(event: any) {
    window.print();
  }
  // method to delete country from arrary list
  deleteDocumentSubCategory(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.documentSubCategoryForm.controls
          .DocumentSubCategories as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.documentSubCategories.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.documentSubCategories[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onSubmit(formValue: any) {
    formValue.type = 'documentSubCategory';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift('documentSubCategory');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
